import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import type { LoginResponse } from '../api/types';

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api<LoginResponse>('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ username, password }),
      });
      navigate('/');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="card">
        <h1>drop</h1>
        <p className="muted" style={{ marginBottom: 24 }}>
          Out-of-band secret share. Sign in to create drops.
        </p>
        {error && <div className="error-banner">{error}</div>}
        <form onSubmit={submit}>
          <label className="label" htmlFor="username">Username</label>
          <input
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
          <div style={{ height: 12 }} />
          <label className="label" htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          <div style={{ height: 16 }} />
          <button type="submit" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'signing in…' : 'sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
